// import React, { useState } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import { Dropdown } from "react-bootstrap";
// import "./App.css";
// import Network from "./components/Network";
// import table from "../src/table.png";
// // Your component code here
// function MetricDropdown() {
//   const [selectedOption, setSelectedOption] = useState("options");

//   const handleSelect = (eventKey) => {
//     setSelectedOption(eventKey);
//   };

//   const options = {
//     chart: {
//       type: "column",
//     },
//     title: {
//       text: "Network Comparison: % of Medicare",
//       align: "center",
//       style: {
//         color: "#333333",
//         fontFamily: "'Montserrat', serif",
//         fontSize: "20px",
//         fontWeight: "bold",
//       },
//     },
//     xAxis: {
//       categories: [
//         "Inpatient (IPPS)",
//         "Outpatient (OPPS)",
//         "Professional (PFS)",
//         "Medicare Part B Drugs (DrugB)",
//       ],
//       title: {
//         text: null,
//       },
//       labels: {
//         style: {
//           fontSize: "12px",
//           width: "100px",
//         },
//       },
//     },
//     yAxis: {
//       title: {
//         text: "% of Medicare",
//         style: {
//           fontSize: "14px",
//           fontWeight: "light",
//           fontFamily: "'Roboto Flex', serif",
//         },
//       },
//       plotLines: [
//         {
//           value: 70,
//           dashStyle: "dash",
//           width: 1,
//           color: "#B4B4B4",
//           zIndex: 5,
//           label: {
//             text: "threshold",
//             align: "right",
//             verticalAlign: "top",
//             rotation: 0,
//             x: 10,
//             y: -5,
//             style: {
//               color: "#666",
//               fontSize: "10px",
//               fontWeight: "light",
//             },
//           },
//         },
//       ],
//     },
//     legend: {
//       layout: "horizontal",
//       align: "center",
//       verticalAlign: "bottom",
//       symbolHeight: 12,
//       symbolWidth: 12,
//       symbolRadius: 4,
//       itemStyle: {
//         color: "#333",
//         fontSize: "13px",
//         fontWeight: "500",
//         fontFamily: "'Roboto Flex', serif",
//       },
//       padding: 5,
//     },
//     credits: {
//       enabled: false,
//     },
//     plotOptions: {
//       series: {
//         borderRadius: 3,
//         pointPadding: 0.2,
//         groupPadding: 0.1,
//         dataLabels: {
//           enabled: true,
//           // format: "{y}%",
//           style: {
//             fontSize: "12px",
//             fontWeight: "bold",
//             color: "black",
//           },
//           inside: false,
//         },
//         cursor: "pointer",
//         states: {
//           hover: {
//             enabled: false,
//           },
//         },
//       },
//     },
//     tooltip: {
//       headerFormat:
//         '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
//         '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//       pointFormat:
//         "<span style='margin-right:100px; width:45px'> {series.name}</span> <span style='display: inline-block;position:absolute;padding-left:-2px;width: 50px; text-align:right;right:0'><b>{point.y}%</span></b><br/>",

//       shared: true,
//       backgroundColor: "rgba(255, 255, 255, 1)",
//       borderColor: "#A9A9A9",
//       borderRadius: 7,
//       animation: false,
//       hideDelay: 0,
//       style: {
//         color: "#333",
//         fontFamily: "'Roboto Flex', serif",
//         transition: "none",
//         fontSize: "12px",
//         padding: "8px",
//         shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//         zIndex: 99999,
//       },
//       shadow: true,
//       useHTML: true,
//       outside: true,
//     },
//     series: [
//       {
//         name: "Anthem High Performance Network",
//         data: [244.22, 265.96, 145.86, 133.83],
//         color: "#c4dbd9",
//       },
//       {
//         name: "Anthem Traditional Network",
//         data: [238.45, 260.44, 150.38, 134.62],
//         color: "#f7bf9e",
//       },
//       {
//         name: "BC ID Blue Value POS Network",
//         data: [255.04, 264.34, 145.9, 135.06],
//         color: "#f7e6da",
//       },
//       {
//         name: "BC ID Preferred Blue Network	",
//         data: [255.04, 264.34, 145.9, 135.06],
//         color: "#f4e7bb",
//       },
//     ],
//   };

//   const options1 = {
//     chart: {
//       type: "column",
//     },
//     title: {
//       text: "Categories Comparison: % of Medicare",
//       align: "center",
//       style: {
//         color: "#333333",
//         fontFamily: "'Montserrat', serif",
//         fontSize: "20px",
//         fontWeight: "bold",
//       },
//     },
//     xAxis: {
//       categories: [
//         "Anthem High Performance Network",
//         "Anthem Traditional Network",
//         "BC ID Blue Value POS Network",
//         "BC ID Preferred Blue Network",
//       ],
//       title: {
//         text: null,
//       },
//       labels: {
//         style: {
//           fontSize: "12px",
//           width: "100px",
//         },
//       },
//     },
//     yAxis: {
//       title: {
//         text: "% Discount",
//         style: {
//           fontSize: "14px",
//           fontWeight: "light",
//           fontFamily: "'Roboto Flex', serif",
//         },
//       },
//       plotLines: [
//         {
//           value: 70,
//           dashStyle: "dash",
//           width: 1,
//           color: "#B4B4B4",
//           zIndex: 5,
//           label: {
//             text: "threshold",
//             align: "right",
//             verticalAlign: "top",
//             rotation: 0,
//             x: 10,
//             y: -5,
//             style: {
//               color: "#666",
//               fontSize: "10px",
//               fontWeight: "light",
//             },
//           },
//         },
//       ],
//     },
//     legend: {
//       layout: "horizontal",
//       align: "center",
//       verticalAlign: "bottom",
//       symbolHeight: 12,
//       symbolWidth: 12,
//       symbolRadius: 4,
//       itemStyle: {
//         color: "#333",
//         fontSize: "13px",
//         fontWeight: "500",
//         fontFamily: "'Roboto Flex', serif",
//       },
//       padding: 5,
//     },
//     credits: {
//       enabled: false,
//     },
//     plotOptions: {
//       series: {
//         borderRadius: 3,
//         pointPadding: 0.2,
//         groupPadding: 0.1,
//         dataLabels: {
//           enabled: true,
//           // format: "{y}%",
//           style: {
//             fontSize: "12px",
//             fontWeight: "bold",
//             color: "black",
//           },
//           inside: false,
//         },
//         cursor: "pointer",
//         states: {
//           hover: {
//             enabled: false,
//           },
//         },
//       },
//     },
//     tooltip: {
//       headerFormat:
//         '<span style="font-size: 14px; color: #5A5A5A;">{point.key}</span><br>' +
//         '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//       pointFormat:
//         "<span style='margin-right:100px; width:45px'> {series.name}</span> <span style='display: inline-block;position:absolute;padding-left:-2px;width: 50px; text-align:right;right:0'><b>{point.y}%</span></b><br/>",

//       shared: true,
//       backgroundColor: "rgba(255, 255, 255, 1)",
//       borderColor: "#A9A9A9",
//       borderRadius: 7,
//       animation: false,
//       hideDelay: 0,
//       style: {
//         color: "#333",
//         fontFamily: "'Roboto Flex', serif",
//         transition: "none",
//         fontSize: "12px",
//         padding: "8px",
//         shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//         zIndex: 99999,
//       },
//       shadow: true,
//       useHTML: true,
//       outside: true,
//     },
//     series: [
//       {
//         name: "Inpatient (IPPS)",
//         data: [244.22, 238.45, 255.04, 255.04], // Data changed for testing
//         color: "#c4dbd9",
//       },
//       {
//         name: "Outpatient (OPPS)",
//         data: [265.96, 260.44, 264.34, 264.34],
//         color: "#f7bf9e",
//       },
//       {
//         name: "Professional (PFS)",
//         data: [145.86, 150.38, 145.9, 145.9],
//         color: "#f7e6da",
//       },
//       {
//         name: "Medicare Part B Drugs (DrugB)",
//         data: [133.83, 134.62, 135.06, 135.06],
//         color: "#f4e7bb",
//       },
//     ],
//   };

//   return (
//     <div className="d-flex flex-column gap-3">
//       <Network />
//       {/* <Dropdown onSelect={handleSelect}>
//         <Dropdown.Toggle
//           id="dropdown-basic"
//           style={{
//             backgroundColor: "white",
//             color: "black",
//             border: "1px solid black",
//           }}
//         >
//           {selectedOption === "options"
//             ? "Network Comparison"
//             : "Categories Comparison"}
//         </Dropdown.Toggle>

//         <Dropdown.Menu style={{ backgroundColor: "white" }}>
//           <Dropdown.Item eventKey="options" style={{ color: "black" }}>
//             Network Comparison
//           </Dropdown.Item>
//           <Dropdown.Item eventKey="options1" style={{ color: "black" }}>
//             Categories Comparison
//           </Dropdown.Item>
//         </Dropdown.Menu>
//       </Dropdown> */}
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "column",
//           gap: "30px",
//           background: "white",
//         }}
//       >
//         <HighchartsReact
//           highcharts={Highcharts}
//           options={selectedOption === "options" ? options : options1}
//         />
//         <img
//           src={table}
//           style={{
//             width: "99.5%",
//             margin: "0px auto",
//             border: "1.5px solid #f4f5f7",
//             borderRadius: "8px",
//             marginBottom: "20px",
//           }}
//         ></img>
//       </div>
//     </div>
//   );
// }

// export default MetricDropdown;

import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsOfflineExporting from "highcharts/modules/offline-exporting"; // Import offline exporting
import "../App.css";
import Network from "../components/Network";
import table from "../../src/table.png";

// Initialize Highcharts modules
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
HighchartsOfflineExporting(Highcharts); // Initialize offline exporting

function MetricDropdown() {
  const [setSelectedOption] = useState("options");

  // const handleSelect = (eventKey) => {
  //   setSelectedOption(eventKey);
  // };

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Network Comparison: % of Medicare",
      align: "center",
      style: {
        color: "#333333",
        fontFamily: "'Montserrat', serif",
        fontSize: "20px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: [
        "Inpatient (IPPS)",
        "Outpatient (OPPS)",
        "Professional (PFS)",
        "Medicare Part B Drugs (DrugB)",
      ],
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "12px",
          width: "100px",
        },
      },
    },
    credits: {
      enabled: false,
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          fontSize: "14px",
          fontWeight: "light",
          fontFamily: "'Roboto Flex', serif",
        },
      },
    },
    exporting: {
      enabled: true,
      fallbackToExportServer: false, // Prevents failed fetch requests
      buttons: {
        contextButton: {
          symbol: "menu",
          menuItems: [
            "viewFullscreen",
            "printChart",
            "downloadPNG",
            "downloadJPEG",
            "downloadPDF",
            "downloadSVG",
            "downloadCSV",
            "downloadXLS",
          ],
        },
      },
    },
    legend: {
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 4,
      itemStyle: {
        color: "#333",
        fontSize: "13px",
        fontWeight: "500",
        fontFamily: "'Roboto Flex', serif",
      },
      padding: 5,
    },
    series: [
      {
        name: "Anthem High Performance Network",
        data: [244.22, 265.96, 145.86, 133.83],
        color: "#c4dbd9",
      },
      {
        name: "Anthem Traditional Network",
        data: [238.45, 260.44, 150.38, 134.62],
        color: "#f7bf9e",
      },
      {
        name: "BC ID Blue Value POS Network",
        data: [255.04, 264.34, 145.9, 135.06],
        color: "#f7e6da",
      },
      {
        name: "BC ID Preferred Blue Network",
        data: [255.04, 264.34, 145.9, 135.06],
        color: "#f4e7bb",
      },
    ],
  };

  return (
    <div
      className="d-flex flex-column gap-3"
      style={{ margin: "0px 20px !important" }}
    >
      <Network />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          background: "white",
        }}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />
        <img
          src={table}
          style={{
            width: "99.5%",
            margin: "0px auto",
            border: "1.5px solid #f4f5f7",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
          alt="Data Table"
        />
      </div>
    </div>
  );
}

export default MetricDropdown;
